export default __webpack_public_path__ + "static/media/apple.d2816e32.svg";